import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { DateFormatEnum } from '@app/models';

@Directive({
  selector: '[appValidDate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidDateDirective,
      multi: true
    }
  ],
  standalone: false
})
export class ValidDateDirective implements Validator {
  @Input('appValidDate') dateFormat: DateFormatEnum;

  static validator(control: AbstractControl, dateFormat: DateFormatEnum): ValidationErrors | null {
    dateFormat = dateFormat || DateFormatEnum.DdMmYyyy;
    const format = `date_format.${dateFormat.toLowerCase()}`;
    return !dateFormat || !control.value || this.isDateValid(control.value, dateFormat) ? null : { appValidDate: { format } };
  }

  static isDateValid(value: string, dateFormat: DateFormatEnum) {
    if (!value) return false;

    let day;
    let month;
    let year;

    if (dateFormat === DateFormatEnum.MmDdYyyy) {
      [month, day, year] = value.split('/').map(Number);
    } else {
      [day, month, year] = value.split('/').map(Number);
    }

    if (!year || !month || !day) {
      return false;
    }

    let thisDate = new Date(year, month - 1, day);
    return thisDate.getFullYear() === year && thisDate.getMonth() === month - 1 && thisDate.getDate() === day;
  }

  constructor() {}

  validate(control: AbstractControl): ValidationErrors | null {
    return ValidDateDirective.validator(control, this.dateFormat);
  }
}
